module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lg1bZg/tc-custom/9781473885400.jpg?1731795474946",
      "alt": "This image is the cover for the book Carthage at War"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Carthage at War\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("The Carthaginians are well known as Rome's great enemy of the three Punic wars and Hannibal, their greatest general, is a household name. While narrative histories of the Punic wars (especially the second) and biographies of Hannibal abound, there have been few studies dedicated to detailed analysis of Carthaginian armies and warfare throughout the city-state's entire existence. Joshua Hall puts that right with this in-depth study of their tactics, equipment, unit organization, army composition and operational effectiveness. Importantly, while the Second Punic War is rightly given prominence, this is not at the expense of the many earlier wars Carthage waged as she built and then defended her empire. Drawing on all the available archaeological and literary evidence, the author shows the development of Carthage's forces and methods of warfare from the ninth century BC to the city's demise. The result is the most in-depth portrait of the Carthaginian military available in English.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Joshua R. Hall\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Joshua Hall majored in History at Western Oregon University, then moved to Cardiff University, Wales, to complete his an MA in Ancient and Medieval Warfare (specializing in warfare in ancient Sicily) and a PhD in ancient history on warfare in Archaic Italy. He currently resides in his home state of Oregon and continues to research and write about the ancient world.He has remained at Cardiff as a Postgraduate Teaching Assistant while working towards his PhD on warfare in Archaic Italy.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Pen and Sword Military\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0